/**
 * UI state — current site context, side nav collapsed, command palette visibility,
 * etc. This is ephemeral state that the backend doesn't care about.
 */
import { defineStore } from "pinia";
import { ref, watch } from "vue";

const STORAGE = {
  sidebar: "wecam-sidebar-collapsed",
  currentSite: "wecam-current-site-id",
};

export const useUiStore = defineStore("ui", () => {
  const sidebarCollapsed = ref(false);
  const currentSiteId = ref<string | null>(null);
  const commandPaletteOpen = ref(false);

  function init() {
    sidebarCollapsed.value = localStorage.getItem(STORAGE.sidebar) === "1";
    currentSiteId.value = localStorage.getItem(STORAGE.currentSite);

    watch(sidebarCollapsed, (v) => {
      localStorage.setItem(STORAGE.sidebar, v ? "1" : "0");
    });
    watch(currentSiteId, (id) => {
      if (id) localStorage.setItem(STORAGE.currentSite, id);
      else localStorage.removeItem(STORAGE.currentSite);
    });
  }

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }

  function setCurrentSite(id: string | null) {
    currentSiteId.value = id;
  }

  function toggleCommandPalette() {
    commandPaletteOpen.value = !commandPaletteOpen.value;
  }

  return {
    sidebarCollapsed,
    currentSiteId,
    commandPaletteOpen,
    init,
    toggleSidebar,
    setCurrentSite,
    toggleCommandPalette,
  };
});
